import { render, staticRenderFns } from "./SingleSwitchWidget.vue?vue&type=template&id=0eb5e893"
import script from "./SingleSwitchWidget.vue?vue&type=script&lang=js"
export * from "./SingleSwitchWidget.vue?vue&type=script&lang=js"
import style0 from "./SingleSwitchWidget.vue?vue&type=style&index=0&id=0eb5e893&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports